/**
 * @enum CONTROL_SECTION
 * @type {{LAYOUT: string, BACKGROUND: string}}
 */
export const CONTROL_SECTION = {
  LAYOUT: 'LAYOUT',
  BACKGROUND: 'BACKGROUND',
};
